import { useLayoutEffect } from "react";
import { onlineManager } from "@tanstack/react-query";
import { useKomutStore } from "@lib/store";

function syncConnectivity(online: boolean) {
  useKomutStore.getState().setIsOnline(online);
  onlineManager.setOnline(online);
}

/** Syncs navigator.onLine into Zustand and TanStack Query onlineManager. */
export function ConnectivityMonitor() {
  useLayoutEffect(() => {
    if (typeof window === "undefined") return;
    syncConnectivity(navigator.onLine);

    const handleOnline = () => syncConnectivity(true);
    const handleOffline = () => syncConnectivity(false);

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);
    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  return null;
}
